import { SVGProps } from 'react';

export const CategoryTravelGold = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg {...props} width='186' height='225' viewBox='0 0 186 225' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M111.082 101.391C139.08 101.391 161.777 78.6935 161.777 50.6953C161.777 22.697 139.08 0 111.082 0C83.0839 0 60.3868 22.697 60.3868 50.6953C60.3868 78.6935 83.0839 101.391 111.082 101.391Z'
      fill='#FAD52F'
    />
    <path
      d='M38.0247 147.312C18.5116 147.312 2.69287 162.987 2.69287 182.318C2.69287 201.649 18.5116 217.325 38.0247 217.325C57.5379 217.325 73.3566 201.649 73.3566 182.318C73.3566 162.987 57.5379 147.312 38.0247 147.312ZM38.0247 214.398C20.1507 214.398 5.64586 200.036 5.64586 182.318C5.64586 164.6 20.1377 150.239 38.0247 150.239C55.8988 150.239 70.4036 164.6 70.4036 182.318C70.3906 200.036 55.8988 214.398 38.0247 214.398Z'
      fill='#F3E3CB'
    />
    <path
      d='M38.0247 144.658C17.0285 144.658 0 161.517 0 182.331C0 203.132 17.0285 220.005 38.0247 220.005C59.0209 220.005 76.0494 203.145 76.0494 182.331C76.0364 161.517 59.0209 144.658 38.0247 144.658ZM38.0247 216.83C18.7847 216.83 3.18715 201.376 3.18715 182.318C3.18715 163.26 18.7847 147.806 38.0247 147.806C57.2647 147.806 72.8622 163.26 72.8622 182.318C72.8492 201.389 57.2647 216.83 38.0247 216.83Z'
      fill='#775419'
    />
    <path
      d='M38.0248 185.297C40.2232 185.297 42.0054 183.515 42.0054 181.317C42.0054 179.118 40.2232 177.336 38.0248 177.336C35.8263 177.336 34.0441 179.118 34.0441 181.317C34.0441 183.515 35.8263 185.297 38.0248 185.297Z'
      fill='#9E8215'
    />
    <path
      d='M38.0248 183.047C37.6996 183.047 37.3613 182.956 37.0621 182.76C36.2686 182.227 36.0474 181.147 36.5808 180.354L43.5405 169.947C43.5795 169.895 46.5065 165.524 47.8855 159.761L55.8989 124.403C56.107 123.466 57.0436 122.881 57.9673 123.102C58.9039 123.31 59.4893 124.247 59.2681 125.171L51.2547 160.541C51.2547 160.554 51.2547 160.554 51.2547 160.567C49.7197 166.968 46.5455 171.69 46.4155 171.898L39.4557 182.305C39.1305 182.773 38.5842 183.047 38.0248 183.047Z'
      fill='#FAD52F'
    />
    <path
      d='M114.477 137.49H55.4954C54.5328 137.49 53.7653 136.71 53.7653 135.76C53.7653 134.797 54.5458 134.03 55.4954 134.03H114.477C115.44 134.03 116.207 134.81 116.207 135.76C116.207 136.71 115.44 137.49 114.477 137.49Z'
      fill='#FAD52F'
    />
    <path
      d='M101.013 197.278C106.596 197.278 111.121 192.753 111.121 187.171C111.121 181.588 106.596 177.063 101.013 177.063C95.4308 177.063 90.9054 181.588 90.9054 187.171C90.9054 192.753 95.4308 197.278 101.013 197.278Z'
      fill='#9E8215'
    />
    <path d='M56.7817 134.641L54.1906 136.934L99.6987 188.347L102.29 186.053L56.7817 134.641Z' fill='#FAD52F' />
    <path
      d='M147.702 147.312C128.189 147.312 112.37 162.987 112.37 182.318C112.37 201.649 128.189 217.325 147.702 217.325C167.215 217.325 183.034 201.649 183.034 182.318C183.034 162.987 167.215 147.312 147.702 147.312ZM147.702 214.398C129.828 214.398 115.323 200.036 115.323 182.318C115.323 164.6 129.815 150.239 147.702 150.239C165.576 150.239 180.081 164.6 180.081 182.318C180.068 200.036 165.576 214.398 147.702 214.398Z'
      fill='#F3E3CB'
    />
    <path
      d='M147.702 144.658C126.706 144.658 109.677 161.517 109.677 182.331C109.677 203.132 126.706 220.005 147.702 220.005C168.698 220.005 185.727 203.145 185.727 182.331C185.714 161.517 168.698 144.658 147.702 144.658ZM147.702 216.83C128.462 216.83 112.864 201.376 112.864 182.318C112.864 163.26 128.462 147.806 147.702 147.806C166.942 147.806 182.539 163.26 182.539 182.318C182.526 201.389 166.942 216.83 147.702 216.83Z'
      fill='#775419'
    />
    <path
      d='M59.1119 126.354C59.0468 126.354 58.9688 126.354 58.9038 126.341L51.4887 125.444C50.5391 125.327 49.8626 124.468 49.9797 123.519C50.0968 122.569 50.9554 121.892 51.905 122.01L59.32 122.907C60.2697 123.024 60.9461 123.883 60.8291 124.832C60.725 125.704 59.9705 126.354 59.1119 126.354Z'
      fill='#FAD52F'
    />
    <path d='M117.76 120.457L111.652 143.198L113.838 143.785L119.946 121.045L117.76 120.457Z' fill='#775419' />
    <path
      d='M101.013 188.901C100.87 188.901 100.714 188.888 100.558 188.836C99.6344 188.589 99.088 187.639 99.3352 186.715L113.853 132.677C114.1 131.753 115.05 131.207 115.973 131.454C116.897 131.701 117.443 132.651 117.196 133.574L102.678 187.613C102.47 188.393 101.768 188.901 101.013 188.901Z'
      fill='#FAD52F'
    />
    <path
      d='M147.702 185.844C150.202 185.844 152.229 183.817 152.229 181.317C152.229 178.816 150.202 176.79 147.702 176.79C145.202 176.79 143.175 178.816 143.175 181.317C143.175 183.817 145.202 185.844 147.702 185.844Z'
      fill='#9E8215'
    />
    <path
      d='M108.832 115.427H132.404L133.041 117.573L126.966 121.489C126.966 121.489 120.696 125.73 115.349 120.774C115.349 120.774 114.074 119.473 112.045 119.473H108.819V115.427H108.832Z'
      fill='#FF5E00'
    />
    <path
      d='M132.417 117.743C133.078 117.743 133.613 117.224 133.613 116.585C133.613 115.945 133.078 115.427 132.417 115.427C131.756 115.427 131.22 115.945 131.22 116.585C131.22 117.224 131.756 117.743 132.417 117.743Z'
      fill='#FF5E00'
    />
    <path
      d='M108.832 119.46C109.988 119.46 110.926 118.557 110.926 117.443C110.926 116.33 109.988 115.427 108.832 115.427C107.675 115.427 106.737 116.33 106.737 117.443C106.737 118.557 107.675 119.46 108.832 119.46Z'
      fill='#FF5E00'
    />
    <path
      d='M148.157 182.253C147.793 182.253 147.429 182.084 147.194 181.759L113.853 136.475C113.463 135.942 113.58 135.187 114.113 134.797C114.646 134.407 115.401 134.524 115.791 135.057L149.133 180.341C149.523 180.874 149.406 181.629 148.873 182.019C148.651 182.175 148.404 182.253 148.157 182.253Z'
      fill='#FAD52F'
    />
    <path
      d='M101 188.901C100.142 188.901 99.3873 188.263 99.2832 187.379C99.1661 186.429 99.8426 185.557 100.792 185.44L147.481 179.586C148.43 179.469 149.302 180.146 149.419 181.095C149.536 182.045 148.86 182.917 147.91 183.034L101.222 188.888C101.143 188.901 101.078 188.901 101 188.901Z'
      fill='#FAD52F'
    />
    <path
      d='M51.5148 125.444C46.6626 124.924 45.5048 121.853 45.5698 120.253V116.273H49.0301V120.344C49.0432 120.54 49.2383 121.71 51.8921 121.997L51.5148 125.444Z'
      fill='#775419'
    />
    <path
      d='M84.8304 181.095L101.508 185.505C102.431 185.753 102.991 186.702 102.743 187.626C102.496 188.55 101.547 189.109 100.623 188.862C100.519 188.836 84.271 183.372 84.1539 183.333C82.7489 182.813 83.3473 180.757 84.8304 181.095Z'
      fill='#FAD52F'
    />
    <path
      d='M89.8517 180.068C90.0468 180.627 89.7476 181.252 89.1883 181.447L79.8479 184.738C79.2886 184.933 78.6641 184.634 78.469 184.075C78.2739 183.515 78.5731 182.891 79.1325 182.696L88.4728 179.404C89.0322 179.209 89.6436 179.508 89.8517 180.068Z'
      fill='#9E8215'
    />
    <path
      d='M79.4838 185.284C79.2496 185.284 79.0154 185.232 78.8073 185.128C78.43 184.946 78.1439 184.634 78.0008 184.231C77.7146 183.411 78.1439 182.513 78.9634 182.227L88.3037 178.936C89.1233 178.65 90.0209 179.079 90.3071 179.899C90.5933 180.718 90.164 181.616 89.3444 181.902L80.0041 185.193C79.835 185.258 79.6529 185.284 79.4838 185.284ZM88.8241 179.834C88.759 179.834 88.694 179.847 88.6289 179.873L79.2886 183.164C78.9764 183.268 78.8203 183.606 78.9244 183.918C78.9764 184.062 79.0805 184.192 79.2236 184.257C79.3667 184.322 79.5228 184.335 79.6789 184.283L89.0192 180.991C89.3314 180.887 89.4875 180.549 89.3835 180.237C89.3054 179.99 89.0712 179.834 88.8241 179.834Z'
      fill='#9E8215'
    />
    <path
      d='M52.1133 108.936L43.8397 109.482C43.8397 109.482 41.9014 109.43 41.9014 111.837V115.843C41.9144 116.195 42.0445 116.949 42.7209 117.339L46.5455 120.162L45.4137 115.388C45.4137 115.388 45.2837 112.175 47.9375 114.217L49.9928 118.094L52.9328 115.089C52.9328 115.089 54.676 113.45 54.4939 111.876L52.1133 108.936Z'
      fill='white'
    />
    <path
      d='M47.8417 119.83C47.8867 119.503 47.5538 119.187 47.0983 119.124C46.6428 119.062 46.237 119.276 46.192 119.604C46.1471 119.931 46.4799 120.247 46.9354 120.31C47.3909 120.372 47.7967 120.158 47.8417 119.83Z'
      fill='white'
    />
    <path d='M44.8022 114.1C44.8022 114.1 46.0121 110.965 48.6529 113.411L44.8022 114.1Z' fill='#F3E3CB' />
    <path
      d='M47.287 119.564C49.1047 119.564 50.5782 118.09 50.5782 116.273C50.5782 114.455 49.1047 112.981 47.287 112.981C45.4693 112.981 43.9957 114.455 43.9957 116.273C43.9957 118.09 45.4693 119.564 47.287 119.564Z'
      fill='#DAAA61'
    />
    <path
      d='M47.287 118.926C48.7526 118.926 49.9408 117.738 49.9408 116.273C49.9408 114.807 48.7526 113.619 47.287 113.619C45.8213 113.619 44.6332 114.807 44.6332 116.273C44.6332 117.738 45.8213 118.926 47.287 118.926Z'
      fill='#9E8215'
    />
    <path d='M85.4548 207.802L85.8191 216.31L90.3071 218.808L96.1351 214.944V209.636L85.4548 207.802Z' fill='#F3E3CB' />
    <path
      d='M96.6684 131.389L80.2643 136.436L80.8887 103.017L80.5635 89.0322C80.5635 89.0322 79.874 67.5286 84.8954 64.3545L96.6684 131.389Z'
      fill='#9E8215'
    />
    <path d='M62.4813 104.291L51.1766 109.248L53.232 113.462L64.5757 109.82L62.4813 104.291Z' fill='white' />
    <path
      d='M59.5926 115.849C60.2992 115.565 60.0424 113.271 59.019 110.724C57.9956 108.177 56.5931 106.343 55.8864 106.627C55.1798 106.911 55.4366 109.206 56.46 111.752C57.4834 114.299 58.8859 116.133 59.5926 115.849Z'
      fill='#9E8215'
    />
    <path d='M83.0743 94.1577L55.8599 106.62L59.5414 115.843L82.8791 108.558L83.0743 94.1577Z' fill='#9E8215' />
    <path d='M78.9894 98.0732L81.7733 71.145L84.5181 93.1559L78.9894 98.0732Z' fill='#9E8215' />
    <path
      d='M87.9655 66.826L86.8337 57.6418L82.3067 62.2209C82.0205 62.5592 81.1749 63.6779 81.6172 65.6292L84.6092 77.2981L87.9655 66.826Z'
      fill='#775419'
    />
    <path d='M97.3188 50.071L95.6537 50.0971L96.6293 51.8403L97.3188 50.071Z' fill='#775419' />
    <path
      d='M94.2096 45.4788L97.5789 53.323L86.8857 62.9495L84.0368 57.746C84.0368 57.746 82.3586 55.1573 82.931 52.5165L94.2096 45.4788Z'
      fill='#F3E3CB'
    />
    <path d='M115.011 112.604L124.728 106.659L113.033 101.169L115.011 112.604Z' fill='#9E8215' />
    <path
      d='M126.315 88.5769C126.315 88.5769 128.982 87.315 127.72 83.7376L121.944 67.2945C121.944 67.2945 119.889 60.9462 118.861 67.2685L116.39 92.7657L126.315 88.5769Z'
      fill='#9E8215'
    />
    <path
      d='M118.497 70.1172L125.509 100.636C125.509 100.636 127.447 107.023 123.115 107.114L118.198 107.218C118.198 107.218 114.1 107.582 114.79 101.781L118.497 70.1172Z'
      fill='white'
    />
    <path
      d='M118.861 67.2685C119.161 65.3953 119.564 64.6407 119.967 64.4976V64.4846L112.032 65.8766L114.842 102.639L118.861 67.2685Z'
      fill='#775419'
    />
    <path
      d='M117.118 131.272C117.118 131.272 115.596 142.043 108.025 150.252L102.965 156.535L99.192 210.716L85.0775 209.663C85.0775 209.663 84.3099 180.276 84.0498 170.61C83.8156 161.543 83.5294 133.626 83.5294 133.626L117.118 131.272Z'
      fill='#775419'
    />
    <path
      d='M130.843 200.83L136.137 206.515L146.349 204.837L145.373 200.882L138.7 193.766L130.843 200.83Z'
      fill='white'
    />
    <path d='M136.137 206.515L138.817 206.072L140.976 196.186L131.792 201.845L136.137 206.515Z' fill='#F3E3CB' />
    <path
      d='M112.357 136.917L116.182 155.403C116.182 155.403 117.938 163.403 122.231 169.518C122.231 169.518 129.815 180.445 140.898 195.405L129.958 204.329C129.958 204.329 101.065 171.131 98.9449 169.166L100.389 151.63L112.357 136.917Z'
      fill='#775419'
    />
    <path
      d='M85.3507 62.9885C85.3507 62.9885 84.31 63.9642 84.2449 66.8782C84.1799 69.4539 82.2416 137.62 82.2416 137.62L120.409 129.971L115.999 100.415L114.074 74.3452L108.91 59.3721L99.127 53.6873L85.3507 62.9885Z'
      fill='#9E8215'
    />
    <path
      d='M101.937 127.733C90.3851 129.307 80.3163 133.132 80.2643 136.514C80.2252 139.714 90.6062 140.469 102.158 138.362C112.669 136.449 120.487 132.82 120.422 130.114C120.37 127.408 112.461 126.289 101.937 127.733Z'
      fill='#9E8215'
    />
    <path
      d='M96.1739 125.105L93.2469 135.695L93.377 139.025L103.277 137.477C103.277 137.477 104.044 133.743 103.355 130.127C102.665 126.51 103.069 123.388 103.212 122.178L96.1739 125.105Z'
      fill='white'
    />
    <path
      d='M93.6244 134.368C93.6244 134.368 93.2602 135.591 93.3252 137.243L92.6357 135.213L93.6244 134.368Z'
      fill='#9E8215'
    />
    <path
      d='M95.2894 73.2002C95.1073 64.4973 99.153 57.3555 104.331 57.2514C109.235 57.1474 113.398 63.4046 113.97 71.47C113.97 71.405 113.97 71.353 113.97 71.2879C113.788 62.7411 108.832 55.9115 102.887 56.0416C96.9415 56.1717 92.2714 63.1965 92.4535 71.7432C92.5966 78.2476 95.4976 83.7503 99.5043 85.9618C97.0586 83.1519 95.3935 78.5078 95.2894 73.2002Z'
      fill='#FAD52F'
    />
    <path
      d='M114.113 72.3808C114.282 80.4593 110.237 87.0938 105.059 87.1978C99.8946 87.3019 95.5627 80.8495 95.3935 72.7711C95.2244 64.6926 99.2702 57.889 104.448 57.9541C110.575 58.0191 113.944 64.3024 114.113 72.3808Z'
      fill='#9E8215'
    />
    <path
      d='M93.8975 125.6L97.3188 97.8783L95.4065 72.7714L114.113 72.3811L114.503 91.1008C114.503 91.1008 114.646 99.9988 112.89 107.336L109.339 122.907C109.352 122.907 99.7644 126.159 93.8975 125.6Z'
      fill='#9E8215'
    />
    <path
      d='M68.114 224.103C69.7449 224.103 71.067 223.171 71.067 222.021C71.067 220.872 69.7449 219.94 68.114 219.94C66.4831 219.94 65.161 220.872 65.161 222.021C65.161 223.171 66.4831 224.103 68.114 224.103Z'
      fill='#FF5E00'
    />
    <path
      d='M95.3675 225H69.493C69.493 225 66.4229 224.935 65.2651 222.593L67.2685 220.018L71.3793 219.51C71.3793 219.51 73.916 219.133 75.8283 217.663L83.3474 211.848L83.4124 211.796C83.4124 211.796 83.4514 211.757 83.5165 211.705C83.5295 211.692 83.5425 211.679 83.5555 211.666C83.7766 211.51 84.0368 211.432 84.323 211.432C84.8824 211.432 85.3637 211.77 85.5849 212.251C85.5979 212.29 85.6109 212.316 85.6239 212.343C85.6239 212.343 85.6239 212.342 85.6239 212.355C86.4304 214.281 88.4078 215.959 90.7103 216.466C93.4422 217.065 95.6927 215.842 96.122 213.669C96.122 213.656 96.122 213.656 96.122 213.656C96.148 213.526 96.2001 213.409 96.2781 213.305C96.4472 213.058 96.7464 212.889 97.0716 212.889C97.553 212.889 97.9562 213.24 98.0343 213.708C98.0343 213.734 98.0473 213.747 98.0473 213.773L99.14 222.32C99.14 222.32 99.5953 225 95.3675 225Z'
      fill='#FF5E00'
    />
    <path
      d='M150.668 201.649L146.011 198.293L144.554 199.477C144.814 199.997 144.97 200.543 144.97 201.116C144.97 203.705 141.978 205.617 138.296 205.396C136.501 205.292 134.875 204.693 133.678 203.809C133.652 203.796 133.626 203.796 133.6 203.783L131.389 214.671C131.389 214.671 130.947 217.312 128.709 218.652L126.185 220.031L125.665 220.356C124.767 221.019 124.195 221.631 124.312 222.515C124.338 222.763 124.416 222.997 124.546 223.218C124.702 223.491 124.923 223.725 125.197 223.894C125.808 224.285 126.654 224.376 127.499 224.141L127.863 224.011C127.863 224.011 127.876 224.011 127.876 223.998L135.643 221.93C135.643 221.93 140.196 220.278 143.318 217.156L152.06 208.492C152.021 208.505 155.455 205.045 150.668 201.649Z'
      fill='#FF5E00'
    />
    <path
      d='M145.412 200.036C145.951 200.036 146.388 199.599 146.388 199.06C146.388 198.522 145.951 198.085 145.412 198.085C144.873 198.085 144.437 198.522 144.437 199.06C144.437 199.599 144.873 200.036 145.412 200.036Z'
      fill='#FF5E00'
    />
    <path
      d='M93.364 138.31L93.5461 142.785C93.5461 142.785 93.5982 143.942 94.3397 144.528L96.7073 145.803C96.7073 145.803 97.8 146.414 98.4765 145.868C98.6846 145.699 98.7627 145.282 98.3464 144.762L96.265 142.459L95.9918 137.997L93.364 138.31Z'
      fill='white'
    />
    <path
      d='M95.6147 138.492L95.7708 142.381C95.7708 142.381 95.3936 143.825 96.9286 144.554L98.7108 145.425C98.7108 145.425 100.181 146.232 101.235 144.749C102.288 143.266 101.104 144.111 101.104 144.111L99.2442 142.238L98.2946 138.101L95.6147 138.492Z'
      fill='white'
    />
    <path
      d='M98.0732 138.14L98.3855 141.627C98.3855 141.627 98.2814 143.24 99.9725 143.916L101.937 144.762C101.937 144.762 103.888 145.451 104.07 143.604L101.833 141.991L100.597 137.607L98.0732 138.14Z'
      fill='white'
    />
    <path
      d='M100.519 137.828L100.909 140.196C100.909 140.196 101.013 141.861 102.431 142.68L103.784 143.63C103.784 143.63 104.643 144.137 105.28 143.526C105.709 143.11 105.358 142.628 105.02 142.199L103.823 140.69C103.823 140.69 102.834 139.324 103.316 137.477C103.29 137.49 100.519 136.397 100.519 137.828Z'
      fill='white'
    />
    <path
      d='M86.6126 25.9395L79.0155 26.6029C79.0155 26.6029 73.9941 30.3104 76.5958 34.8115L86.6126 25.9395Z'
      fill='#775419'
    />
    <path
      d='M79.3666 35.7481C81.8955 35.7481 83.9457 33.6979 83.9457 31.169C83.9457 28.64 81.8955 26.5898 79.3666 26.5898C76.8376 26.5898 74.7875 28.64 74.7875 31.169C74.7875 33.6979 76.8376 35.7481 79.3666 35.7481Z'
      fill='#775419'
    />
    <path
      d='M87.5622 46.3502C93.2093 46.3502 97.7871 41.7723 97.7871 36.1253C97.7871 30.4782 93.2093 25.9004 87.5622 25.9004C81.9151 25.9004 77.3373 30.4782 77.3373 36.1253C77.3373 41.7723 81.9151 46.3502 87.5622 46.3502Z'
      fill='#775419'
    />
    <path
      d='M86.3525 48.0936C91.9995 48.0936 96.5774 43.5158 96.5774 37.8687C96.5774 32.2217 91.9995 27.6438 86.3525 27.6438C80.7054 27.6438 76.1276 32.2217 76.1276 37.8687C76.1276 43.5158 80.7054 48.0936 86.3525 48.0936Z'
      fill='white'
    />
    <path
      d='M94.6129 42.7339L94.4828 41.6802L76.7519 34.3433L75.2428 37.9857C75.1908 38.1158 74.9957 38.6752 75.2428 39.2736L75.516 39.9501C75.516 39.9501 75.7762 40.6005 75.6591 41.277L75.399 42.786C75.399 42.786 74.7745 45.6349 75.8933 47.7943L78.5471 52.8548C78.5471 52.8548 80.6545 57.7461 89.8517 51.697C89.8387 51.697 95.4065 48.0545 94.6129 42.7339Z'
      fill='white'
    />
    <path
      d='M93.0909 41.0299C93.5332 39.9631 94.704 39.4428 95.7057 39.8591C96.096 40.0152 96.3952 40.3014 96.6033 40.6396C96.9806 39.2607 98.4896 32.8994 94.5999 30.2196C94.5999 30.2196 92.0112 26.9804 87.3801 27.0454L79.7829 27.5528L77.2462 31.4814C77.2462 31.4814 85.3637 30.935 85.4288 30.935C85.9751 30.909 86.5475 30.9871 87.0939 31.2212C88.6159 31.8457 89.5135 33.3417 89.4485 34.9027C89.8648 35.0068 91.3738 35.6182 91.2957 38.6623L91.3478 42.5779L92.9088 42.6299L92.9348 41.7844C92.9478 41.5242 92.9999 41.264 93.0909 41.0299Z'
      fill='#775419'
    />
    <path d='M89.4486 34.5903C89.4486 34.5903 89.4486 34.8896 89.7608 35.0066H89.2014L89.4486 34.5903Z' fill='white' />
    <path
      d='M93.2471 40.7305C93.2471 40.7305 94.7561 38.3759 96.5643 40.3012C98.2295 42.0834 94.2618 48.861 92.6227 46.0511L93.2471 40.7305Z'
      fill='white'
    />
    <path
      d='M79.0414 31.3511C79.0414 31.3511 78.326 31.3771 77.7666 32.3137L77.4023 30.5315L79.0414 31.3511Z'
      fill='#775419'
    />
    <path
      d='M91.3348 42.3176C91.3348 42.3176 91.3088 42.5648 91.5689 42.5778L91.1396 42.7729L91.3348 42.3176Z'
      fill='white'
    />
    <path
      d='M96.9285 50.344L85.3507 62.9755L89.1233 67.0733L99.6864 53.7783L98.4636 51.0204C98.4636 51.0204 97.9042 49.3293 96.9285 50.344Z'
      fill='#DAAA61'
    />
    <path
      d='M88.2386 66.1368C88.2386 66.1368 89.0452 67.1776 90.1119 65.8376L90.5412 66.8393L88.6029 67.6849C88.6029 67.6849 87.9394 66.8913 88.2386 66.1368Z'
      fill='#9E8215'
    />
    <path
      d='M101.927 125.795C106.191 125.024 109.522 123.712 109.369 122.863C109.216 122.015 105.635 121.952 101.372 122.722C97.1084 123.493 93.7766 124.806 93.9299 125.654C94.0833 126.503 97.6638 126.566 101.927 125.795Z'
      fill='#9E8215'
    />
    <path
      d='M99.1877 210.686C99.252 209.776 96.1436 208.815 92.245 208.539C88.3463 208.264 85.1338 208.779 85.0695 209.689C85.0052 210.599 88.1136 211.56 92.0122 211.835C95.9108 212.111 99.1234 211.596 99.1877 210.686Z'
      fill='#775419'
    />
    <path
      d='M136.767 201.452C139.762 198.941 141.598 196.2 140.869 195.331C140.14 194.461 137.12 195.791 134.125 198.302C131.13 200.813 129.294 203.554 130.023 204.424C130.752 205.294 133.772 203.964 136.767 201.452Z'
      fill='#775419'
    />
    <path
      d='M60.1136 219.901H22.8434C22.4661 219.901 22.1539 219.588 22.1539 219.211C22.1539 218.834 22.4661 218.522 22.8434 218.522H60.1136C60.4908 218.522 60.8031 218.834 60.8031 219.211C60.8031 219.588 60.4908 219.901 60.1136 219.901Z'
      fill='#775419'
    />
    <path
      d='M169.791 219.901H148.339C147.962 219.901 147.65 219.588 147.65 219.211C147.65 218.834 147.962 218.522 148.339 218.522H169.791C170.168 218.522 170.48 218.834 170.48 219.211C170.48 219.588 170.168 219.901 169.791 219.901Z'
      fill='#775419'
    />
  </svg>
);
